import { Box, alpha } from '@mui/material'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  boxScrollable: {
    overflow: 'overlay',
    overflowX: 'hidden',
    '&:hover, &:focus-within': {
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: alpha(theme.palette.common.black, 0.15),
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.black, 0.3),
        },
      },
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: alpha(theme.palette.common.black, 0),
    },
  },
}))

const BoxScrollable = (props) => {
  const { boxScrollable } = useStyles()
  return <Box className={boxScrollable} {...props} />
}

BoxScrollable.propTypes = {
  children: PropTypes.node,
}

export default BoxScrollable
